import { DateInput } from '../types/UtilityTypes'

/**
 * Converts a Date object to YYYY-MM-DD string format
 * Handles both regular Date objects and Firestore Timestamp objects
 */
const formatDateToString = (inputDate: DateInput): string => {
  const htmldate = !!(inputDate as any).getFullYear
    ? (inputDate as Date)
    : (inputDate as any).toDate()
  const yyyy = htmldate.getFullYear()
  const mm = htmldate.getMonth() + 1 // Months start at 0!
  const dd = htmldate.getDate()
  let smm = mm.toString()
  let sdd = dd.toString()

  if (dd < 10) sdd = '0' + dd
  if (mm < 10) smm = '0' + mm

  return yyyy + '-' + smm + '-' + sdd
}

/**
 * Creates a new Date object with only the date part (no time)
 * Avoids timezone issues by using local date components
 */
const createDateOnly = (htmldate: Date): Date => {
  return new Date(
    htmldate.getFullYear(),
    htmldate.getMonth(),
    htmldate.getDate()
  )
}

/**
 * Generates a consistent color from a string using hash algorithm
 */
const generateColorFromString = (str: string): string => {
  const seed = str.trim()
  var hash = 0
  for (var i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash)
  }
  var colour = '#'
  for (var j = 0; j < 3; j++) {
    var value = (hash >> (j * 8)) & 0xff
    colour += ('00' + value.toString(16)).slice(-2)
  }
  return colour
}

/**
 * Determines the best contrast color (black or white) for a given hex color
 */
const getContrastColor = (hexcolor: string): 'black' | 'white' => {
  hexcolor = hexcolor.replace('#', '')
  var r = parseInt(hexcolor.substring(0, 2), 16)
  var g = parseInt(hexcolor.substring(2, 4), 16)
  var b = parseInt(hexcolor.substring(4, 6), 16)
  var yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? 'black' : 'white'
}

// Export with both old and new names for backward compatibility during refactoring
export { formatDateToString, formatDateToString as fixDate }
export { createDateOnly, createDateOnly as dateOnly }
export { generateColorFromString, generateColorFromString as stringToColour }
export { getContrastColor, getContrastColor as getContrastYIQ }
